import React from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import Spinner from "../../components/Spinner";
import { connect } from "react-redux";
import axios from "axios";
import { clear_virgil_chad } from "../../redux/actions";

class ClearVirgilChadModal extends React.Component {
  constructor() {
    super();
    this.state = {
      /**
       * working: Boolean - Whether the emission is in the process of being removed
       */
      working: false,
    };
  }

  confirm = () =>
    this.setState(
      (curr) => ({
        ...curr,
        working: true,
      }),
      () =>
        axios
          .get("/search/clear-virgil-chad/" + this.props.flavor)
          .then(() => {
            this.props.clear_virgil_chad(this.props.flavor);
            this.props.toggleShowModal();
          })
          .catch((err) => {
            console.log("error", err);
            alert("An error occurred. Please try again later.");
          })
          .finally(() =>
            this.setState((curr) => ({
              ...curr,
              working: false,
            }))
          )
    );

  render() {
    return (
      <>
        {typeof window !== "undefined" && window.navigator ? (
          <MDBModal
            open={this.props.modalShown}
            staticBackdrop
            onClosePrevented={() => {
              if (!this.state.working) this.props.toggleShowModal();
            }}
            tabIndex="-1"
          >
            <MDBModalDialog
              size={
                this.props.screenDimensions.width >
                this.props.screenDimensions.modalBreak
                  ? "xl"
                  : "fullscreen"
              }
            >
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Clearing {this.props.flavor}</MDBModalTitle>
                  <MDBBtn
                    className="btn-close"
                    color="none"
                    onClick={this.props.toggleShowModal}
                  ></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>
                  <h5 className="text-center display-6 my-4">
                    Are you sure you want to clear the entire chat history?
                  </h5>
                </MDBModalBody>
                <MDBModalFooter>
                  <MDBBtn
                    color="primary"
                    onClick={this.confirm}
                    disabled={this.state.working}
                  >
                    {this.state.working ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Clearing
                      </>
                    ) : (
                      <>
                        <i className="fas fa-check-circle me-2" />
                        Confirm
                      </>
                    )}
                  </MDBBtn>
                  <MDBBtn
                    className="bg-gray"
                    color="dark"
                    onClick={this.props.toggleShowModal}
                  >
                    Close
                  </MDBBtn>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        ) : (
          <></>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  screenDimensions: state.screenDimensions,
});

export default connect(mapStateToProps, { clear_virgil_chad })(
  ClearVirgilChadModal
);
